var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{attrs:{"type":"bar","height":_vm.height ? _vm.height : 350,"options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }